import { render, staticRenderFns } from "./GLInterfaceList.vue?vue&type=template&id=f8b72592&"
import script from "./GLInterfaceList.vue?vue&type=script&lang=js&"
export * from "./GLInterfaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports